export enum PreferredLanguage {
    ENGLISH_US = "en",
    NORWEGIAN = "no"
}